import React, { useState } from 'react';
import axios from 'axios';
import { Atom } from "react-loading-indicators";

function LinkedIntoTwitter() {

  const [linkedinPost, setLinkedinPost] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('gaj.tanwar@feinternational.com');
  const [isLoading, setIsLoading] = useState(false);

  // Styles (matching GenerateBlog.js)
  const styles = {
    pageContainer: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '10vh',
    },
    appContainer: () => ({
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '100%',
      padding: '10px',
    }),
    formContainer: () => ({
      width: '100%',
      maxWidth: '400px',
      transition: 'all 0.5s ease',
      padding: '20px',
    }),
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerText: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      marginTop: '10px',
      marginBottom: '20px',
      borderBottom: '1px solid black',
    },
    input: {
      margin: '5px 0',
      padding: '7px',
      borderRadius: '4px',
      border: '1px solid #cccccc',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
    },
    select: {
      margin: '5px 0',
      padding: '7px',
      borderRadius: '4px',
      border: '1px solid #cccccc',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      backgroundColor: 'white',
    },
    label: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      marginTop: '10px',
      marginBottom: '2px',
      fontWeight: 'bold',
    },
    button: {
      margin: '10px 0',
      padding: '10px',
      backgroundColor: '#6487dc',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '4px',
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      linkedinPost: linkedinPost,
      recipientEmail: recipientEmail,
    };

    axios.post('/api/linkedin_to_twitter_converter', payload, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then((response) => {
      setIsLoading(false);
      if (response.status === 200) {
        alert('Twitter post generated successfully. Please check your email.');
      }
    })
    .catch((error) => {
      setIsLoading(false);
      console.error('Error generating twitter post:', error);
      alert('Error generating twitter post. Please try again.');
    });
  };

  return (
    <div style={styles.appContainer()}>
      <div style={styles.formContainer()}>
        <form onSubmit={handleSubmit} style={styles.form}>
          <h3 style={styles.headerText}>LinkedIn to Twitter Converter</h3>

          <label style={styles.label}>LinkedIn Post</label>
          <textarea
            placeholder="Paste your LinkedIn post here"
            value={linkedinPost}
            onChange={(e) => setLinkedinPost(e.target.value)}
            style={{ ...styles.input, resize: 'vertical', minHeight: '120px' }}
            required
          />

          <label style={styles.label}>Recipient Email</label>
          <select
            value={recipientEmail}
            onChange={(e) => setRecipientEmail(e.target.value)}
            style={styles.select}
            required
          >
            <option value="thomas@feinternational.com">thomas@feinternational.com</option>
            <option value="gaj.tanwar@feinternational.com">gaj.tanwar@feinternational.com</option>
            <option value="sumedh.kadam@feinternational.com">sumedh.kadam@feinternational.com</option>
          </select>

          {isLoading && (
            <div align="center" style={{ marginTop: '20px' }}>
              <Atom color="#32cd32" size="medium" text="Generating Twitter post..." />
            </div>
          )}

          <button type="submit" disabled={isLoading} style={styles.button}>
            Generate Twitter Post
          </button>
        </form>
      </div>
    </div>
  );
}

export default LinkedIntoTwitter;
